import {FETCH_ALL_TAG_CATEGORIES, FETCH_ALL_TAG_CATEGORIES_FAIL} from "../actionTypes";

const initialState = {
    status: 0,
    message: "",
    tagsCategories: [],
    isLoading: true
}

const allTagCategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ALL_TAG_CATEGORIES :
            return {
                tagCategories : action.payload.tagCategories,
                message: action.payload.message,
                status: action.payload.status,
                isLoading: false
            }
        case FETCH_ALL_TAG_CATEGORIES_FAIL:
            return {
                ...state,
                message: action.payload.message,
                status: action.payload.status,
                isLoading: false
            }
        default:
            return {
                ...state
            }

    }
}

export default allTagCategoriesReducer;